import { IBrandPageRedesignXP } from "@faire/web-api/indigofair/seo/IBrandPageRedesignXP";
import { BRAND_PAGE_REDESIGN_091824 } from "@faire/web-api/indigofair/settings/BRAND_PAGE_REDESIGN_091824";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingBrandPageRedesign = (): {
  isTreatment: boolean;
  hideTabsVariant: boolean;
  showCTAVariant: boolean;
} => {
  const setting = useSetting(
    BRAND_PAGE_REDESIGN_091824,
    IBrandPageRedesignXP.Bucket.CONTROL
  );

  return {
    isTreatment: setting !== IBrandPageRedesignXP.Bucket.CONTROL,
    hideTabsVariant: setting === IBrandPageRedesignXP.Bucket.VARIANT_A,
    showCTAVariant:
      setting === IBrandPageRedesignXP.Bucket.VARIANT_A ||
      setting === IBrandPageRedesignXP.Bucket.VARIANT_B,
  };
};

export const useAssignSettingBrandPageRedesign = () =>
  useAssignSetting(BRAND_PAGE_REDESIGN_091824);
